export default __webpack_public_path__ + "static/vision2-c019cffc4361cf3471d8aa556c564929.png";